import { Component, Injector, Input, OnInit } from '@angular/core';
import { ExcelExportGridActionHandler } from '../../../../../components/common/grid-base/actions/excel-export-grid-action-handler';
import { LoadDataGridActionHandler } from '../../../../../components/common/grid-base/actions/load-data-grid-action-handler';
import { SearchGridActionHandler } from '../../../../../components/common/grid-base/actions/search-grid-action-handler';
import { ShowAllGridActionHandler } from '../../../../../components/common/grid-base/actions/show-all-grid-action-handler';
import { UnselectCheckboxesGridActionHandler } from '../../../../../components/common/grid-base/actions/unselect-checkboxes-grid-action-handler';
import { GridActionHandlerBase } from '../../../../../components/common/grid-base/actions/grid-action-handler-base';
import { WorkspaceBase } from '../../../../../components/common/workspace-base/workspace-base';
import { CreateValuationEventFromProjectGridActionHandler } from './actions/create-valuation-event-from-project-grid-action-handler';
import { DeleteProjectGridActionHandler } from './actions/delete-project-grid-action-handler';
import { WorkplaceBase } from '../../../../../components/common/workplace-base/workplace-base';
import { TabConfig } from '../../../../../components/common/pollux-tab-config/pollux-form-config';
import { LoadDataKeepFilterGridActionHandler } from 'src/app/components/common/grid-base/actions/load-data-keep-filter-grid-action-handler';
import { AppStorageService } from '../../../../../services/app-storage.service';

/**
 * Projects workspace
 */
@Component({
  selector: 'projects-workspace',
  templateUrl: './projects-workspace.component.html',
  styleUrls: ['./projects-workspace.component.css']
})
export class ProjectsWorkspaceComponent extends WorkspaceBase implements OnInit {
  /**
   * JavaScript Oid property name of BO (in this case Project DTO)
   */
  public oidPropertyName = "Oid";

  /**
   * Show export pane?
   */
  public showProjectsExportPane = false;

  /**
   * Show the form
   * @param oid Oid of the item that should be loaded in the form. Use -1 for new mode
   */
  public showForm(oid: number): void {
    this.showGrid = false;
    this.oid = oid;

    this.eventBus.broadcastEvent('searchBarVisibility', false);
  }

  /**
   * The workplace
   */
  private _workplace: WorkplaceBase;

  /**
   * Sets the workplace
   */
  @Input() public set workplace(workplace: WorkplaceBase) {
    this._workplace = workplace;
  }

  /**
   * Gets the workplace
   */
  public get workplace(): WorkplaceBase {
    return this._workplace;
  }

  /**
   * The tab element
   */
  private _tabElement: TabConfig;

  /**
   * Sets te tab element
   */
  @Input() public set tabElement(tabElement: TabConfig) {
    this._tabElement = tabElement;
  }

  /**
   * Gets the tab element
   */
  public get tabElement(): TabConfig {
    return this._tabElement;
  }


  /**
   * Closes the export pane
   */
  public closeExportPane(): void {
    this.showProjectsExportPane = false;
  }

  /**
   * Constructor
   * @param injector
   * @param appStorage
   */
  constructor(protected injector: Injector, private appStorage: AppStorageService) {
    super(injector);
  }

  /**
   * Called if the grid state was changed. Use this to notify the nav bar or perform similar actions
   * @param gridState The new grid state: true: Grid is shown, so the form isn't showh. False: Grid isn't show, but the form is shown
   */
  protected onShowGridChanged(gridState: boolean): void {
    this.eventBus.broadcastEvent('showGridChanged', { area: 'projectValuationProjectstd', value: gridState });
  }

  /**
   * Gets the action handlers
   */
  protected get actionHandlers(): GridActionHandlerBase[] {
    return [
      new ExcelExportGridActionHandler(this.injector, this, 'exportToExcelProjectsGrid'),
      new SearchGridActionHandler(this.injector, this, 'project.valuation.projectstd.search'),
      new ShowAllGridActionHandler(this.injector, this, 'project.valuation.projectstd.showAll'),
      new LoadDataGridActionHandler(this.injector, this, 'ProjectstdLoadData'),
      new DeleteProjectGridActionHandler(this.injector, this),
      new LoadDataKeepFilterGridActionHandler(this.injector, this, 'projectsDataSaved'),
      new CreateValuationEventFromProjectGridActionHandler(this.injector, this),
      new UnselectCheckboxesGridActionHandler(this.injector, this)
    ];
  }

  /**
   * Registers any required events. Please don't forget to unsubscibe!
   */
  protected registerEvents(): void {
    window.addEventListener("beforeunload", () => {
      sessionStorage.removeItem('filter');
      sessionStorage.removeItem('pageSize');
      sessionStorage.removeItem('paging');
      sessionStorage.removeItem('puid');
      sessionStorage.removeItem('projectName');
      sessionStorage.removeItem('projectStatus');
      sessionStorage.removeItem('client');
    });

    this.onEvents.push(this.eventBus.subscribeEvent('closeProjectstdForm', () => {
      this.showGrid = true;
      this.eventBus.broadcastEvent('showSaveCancelNavigationAction', false);
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('projectsDataSaved', () => {
      this.showGrid = true;
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('newProjectDataFromNav', () => {
      this.oid = null;
      setTimeout(() => {
        this.showGrid = false;
        this.showForm(-1);
        this.eventBus.broadcastEvent('createProjectsData');
      });
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('backClickedTrue', () => { this.showGrid = true; }));

    this.onEvents.push(this.eventBus.subscribeEvent('showProjectsExportPane', () => {
      this.showProjectsExportPane = true;
    }));
  }

  /**
   * Applies a filter if an element was selected in a higher hierarchy area
   * @param _item Item
   * @param _selectedHierarchy Hierarchy where the element was selected
   * @param _tabConfig Tab config
   * @param reset Reset the selection in the current area
   */
  public filter(_item: any, _selectedHierarchy: number, _tabConfig: any, reset: boolean): void {
    if (reset) {
      this.grid.loadData({
        skip: 0
      }, null);
    }
    else {
      if (this.appStorage.getSelectedProject()) {
        return;
      }
      this.grid.loadData({
        skip: 0
      }, null);
    }
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init();

    this.workplace.onTabCreated(this);
  }
}
